import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IImageFilters, IImageFiltersData } from '../../../imageFilters.model';
import { FiltersDropdownRow } from '../FiltersDropdownRow';

interface IInDatasetsFilterInfoProps {
  availableFilters: IImageFiltersData;
  imageFilters: IImageFilters;
}

export const InDatasetsFilterInfo = observer((props: IInDatasetsFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  const selectedOptions = props.availableFilters.datasets
    .slice()
    .sort((a, b) => (a.name > b.name ? 1 : -1))
    .filter((d) => props.imageFilters.datasets.includes(d.id));

  return (
    <FiltersDropdownRow
      label={t('image_filters.datasets')}
      count={selectedOptions.length}
    >
      <>
        {selectedOptions.map((d) => (
          <div key={d.id}>{d.name}</div>
        ))}
      </>
    </FiltersDropdownRow>
  );
});
